import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn, formatTabCount } from '@/lib/utils'

interface TabCountBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	count?: number | null
	active?: boolean
	showCount?: boolean
	tooltipSide?: 'top' | 'right' | 'bottom' | 'left'
}

export function TabCountBadge({
	count,
	active,
	showCount = true,
	className,
	tooltipSide = 'bottom',
	...props
}: TabCountBadgeProps) {
	if (!showCount) {
		return null
	}

	const finalCount = count ?? 0
	const formattedCount = formatTabCount(finalCount)

	const badge = (
		<span
			className={cn(
				'ml-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 whitespace-nowrap tabular-nums transition-colors duration-300 ease-in-out text-control!',
				active
					? 'bg-header-tab-active-counter-bg text-header-tab-active-counter-text'
					: 'bg-header-tab-inactive-counter-bg text-header-tab-inactive-counter-text group-hover:text-header-tab-active-counter-text',
				className,
			)}
			title={finalCount.toLocaleString()}
			{...props}>
			{formattedCount}
		</span>
	)

	if (finalCount > 999) {
		return (
			<Tooltip delayDuration={150}>
				<TooltipTrigger asChild>{badge}</TooltipTrigger>
				<TooltipContent side={tooltipSide} className='z-[500] text-body font-normal'>
					{finalCount.toLocaleString()}
				</TooltipContent>
			</Tooltip>
		)
	}

	return badge
}
